import React from 'react';
import bgimg from '../../../assets/images/appointment.png'


const ContactsUs = () => {
    return (
        <section className='rounded'>
            <div className="hero " style={{ backgroundImage: `url(${bgimg})` }}>
                <div className="hero-overlay bg-opacity-60"></div>
                <div className="hero-content text-center  text-neutral-content">
                    <div className="w-4/6">
                        <h1 className="mb-5 text-3xl font-bold text-info">Contact Us</h1>
                        <p className="mb-5 text-4xl text-white">Stay connected with us</p>
                        <input type="text" placeholder="Email Address" className="input input-bordered w-full " />
                        <input type="text" placeholder="Subject" className="input input-bordered w-full  my-4" />
                        <textarea className="textarea w-full mb-6" placeholder="Your message"></textarea>
                        <button className="btn btn-primary bg-gradient-to-r from-primary to-secondary text-white">Submit</button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ContactsUs;